import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { originalCourses } from '../../../../Data/originalCourses';
import { regionalCourses } from '../../../../Data/regionalCourses';
import { regionalLanguage } from '../../../../Data/regionalLanguage';
import { regionalCourseTypes } from '../../../../Data/regionalCourseTypes';
import { originalPackages } from '../../../../Data/originalPackages';
import { partnerCourses } from '../../../../Data/partnerCourses';
import { courseGroupNames } from '../../../../Data/courseGroupNames';
import { partnerCourseGroups } from '../../../../Data/partnerCourseGroups';
import { juniorsCourses } from '../../../../Data/juniorsCourses';
import { juniorsCourseGroups } from '../../../../Data/juniorsCourseGroups';
import { originalsPaths, partnerPlusPaths, animatedRegionalsPaths } from '../../../../Data/excludedPaths';
import config from '../../../../config';
import { history } from '../../../../Store';
import { HeaderItem } from '../styles/index';
import {
  LargeOuterContainer,
  LargeInnerContainer,
  LargeOuterWrapper,
  LargeInnerWrapper,
  LargeNavWrapper,
  LargeNavBtn,
  LargeNavTitle,
  LargeNavIcon,
  LargeCoursesSection,
  LargeCoursesWrapper,
  LargeCoursesCard,
  CoursesIcon,
  LargeCoursesTitle,
  LargeCoursesDescription,
  LargeCoursesPrimeBar,
  LargeCoursesGroupInfo,
  LargeRegionalsOuterWrapper,
  LargeRegionalsInnerWrapper,
  LargeRegionalsInnerHeader,
  LargeRegionalsCourse,
  RegionalsLangIcon,
  RegionalsLangText,
  MobileCourseIcon,
  MobileNavHrLine,
  CourseTag,
  DurationTabsDivisionWrapper,
  DurationTabsDivision,
  DurationTab,
} from './styles';
import { RiArrowDownSLine } from 'react-icons/ri';
import { BsCaretRightFill } from 'react-icons/bs';

class CoursesLargeNav extends Component {
  state = {
    activeGroup: 'DataStructures',
    activePartnerGroup: 'DataAnalysis',
    activeRegionalsLang: 'tamil',
    activeRegionalsTab: 'animation',
    activeRegionalsGroup: this.props.courseCategory || 'animation',
    activeJuniorsGroup: 'Basics',
    activeVariant: '',
  };

  componentDidMount() {
    const { variant, language, courseCategory } = this.props;
    if (variant === 'partner-plus' || variant === 'code-juniors') this.setState({ activeVariant: variant });
    else if (variant === 'regionals') {
      if (courseCategory === 'professional') this.setState({ activeVariant: `${variant}-expert` });
      else this.setState({ activeVariant: `${variant}-animation` });
    } else this.setState({ activeVariant: 'originals' });

    if (variant === 'regionals' && language) this.setState({ activeRegionalsLang: language });
    // if (variant === 'regionals' && courseCategory) this.setState({ activeRegionalsGroup: courseCategory });
  }

  handleCourseGroup = (courseGroup) => {
    this.setState({ activeGroup: courseGroup });
    this.setState({ activeVariant: 'originals' });
  };
  handlePartnerCourseGroup = (courseGroup) => {
    this.setState({ activePartnerGroup: courseGroup });
    this.setState({ activeVariant: 'partner-plus' });
  };
  handleRegionalsCourseGroup = (language, courseCategory) => {
    this.setState({ activeRegionalsLang: language });
    // this.setState({ activeRegionalsGroup: courseGroup });
    if (courseCategory === 'professional') this.setState({ activeVariant: 'regionals-expert' });
    else this.setState({ activeVariant: 'regionals-animation' });
  };
  // handleRegionalsLangGroup = (courseGroup) => {
  //   this.setState({ activeRegionalsLang: courseGroup });

  //   if (!regionalCourses[courseGroup]['professional']) {
  //     this.setState({ activeRegionalsTab: 'animation' });
  //   }
  // };
  // handleRegionalsCourseTab = (groupTab) => {
  //   this.setState({ activeRegionalsTab: groupTab });
  // };
  handleJuinorsCourseGroup = (courseGroup) => {
    this.setState({ activeJuniorsGroup: courseGroup });
    this.setState({ activeVariant: 'code-juniors' });
  };
  handleCoursesNav = (courseID) => {
    window.location.href = `${config.domain}/${courseID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=courses-nav_bar`;
  };
  handleRegionalCoursesNav = (courseID) => {
    window.location.href = `${config.domain}/${courseID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=courses-nav_bar`;
  };
  handlePackagesNav = (packageID) => {
    window.location.href = `${config.domain}/${packageID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=packages-nav_bar`;
  };
  // handleRegionalLanguage = (id) => {
  //   window.location.href = `${config.domain}/${id}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=regionals-nav_bar`;
  // };

  _renderPrimeNavBar = () => {
    const { darkTheme, isFromInterview, primeOfferPriceLoading, primeOfferPrice, primeOfferLink } = this.props;
    return (
      <Fragment>
        {primeOfferPriceLoading ? (
          <LargeCoursesPrimeBar>
            <SkeletonTheme
              color={darkTheme || isFromInterview ? 'var(--normalTxtColor)' : 'var(--greyBgLight)'}
              highlightColor={darkTheme || isFromInterview ? 'var(--darkGreyTxtColor)' : 'var(--greyShadowColor)'}
            >
              <Skeleton className="d-block no-line-height" height={'32px'} width={'580px'} />
            </SkeletonTheme>
          </LargeCoursesPrimeBar>
        ) : (
          <LargeCoursesPrimeBar
            darkTheme={darkTheme}
            isFromInterview={isFromInterview}
            onClick={() => {
              if (primeOfferLink) history.push(`/lb-spl-off-18fdd2ad71d?user_target_offer=${primeOfferLink}`);
              else history.push('/pricing');
            }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <span className="weight-600 mr-2">All Courses. One Membership:</span>
              <p>
                Become a Prime Member to unlock all courses
                {primeOfferPrice ? ` for just ${primeOfferPrice}.` : '.'}
              </p>
              <span className="weight-600 ml-2">
                Buy now <span className="cta-arrow">➜</span>
              </span>
            </div>
          </LargeCoursesPrimeBar>
        )}
      </Fragment>
    );
  };

  _renderTopGroupInfo = (activeVariant) => {
    const { darkTheme, isFromInterview } = this.props;

    return (
      <Fragment>
        {activeVariant === 'partner-plus' ? (
          <LargeCoursesGroupInfo darkTheme={darkTheme} isFromInterview={isFromInterview}>
            <div className="d-flex align-items-center pb-1">
              <span className="inline-block no-line-height headingFont weight-500">Partner+</span>{' '}
              <CourseTag style={{ margin: '0px 0px 0px 8px', textTransform: 'none', fontSize: '12px' }}>Animated</CourseTag>
            </div>
            Partner+ course content is created by expert educators from our partner network.
          </LargeCoursesGroupInfo>
        ) : activeVariant === 'regionals-expert' ? (
          <LargeCoursesGroupInfo darkTheme={darkTheme} isFromInterview={isFromInterview}>
            <div className="hide-till-large-laptop pb-1">
              <span className="inline-block no-line-height headingFont weight-500">Expert courses</span>
            </div>
            <div>
              <span className="hide-on-large-device no-line-height headingFont weight-500">Expert courses</span> <span className="hide-till-large-laptop">Expert courses</span> are
              developed by industry professionals and are available for separate purchase.{' '}
              <span className="d-inline-block">
                Not included in Prime<span className="hide-till-large-laptop">.</span> <span className="hide-on-large-device">Membership.</span>
              </span>
            </div>
          </LargeCoursesGroupInfo>
        ) : null}
      </Fragment>
    );
  };

  _renderCourseTag = (upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, courseTheme, language) => {
    const { country, userPaidStatus, paidPath } = this.props;
    let noPaidPath = !userPaidStatus || paidPath === undefined;
    let originalsSpecialIndividuals = paidPath && originalsPaths.every((path) => !paidPath.includes(path));
    let partnerPlusSpecialIndividuals = paidPath && partnerPlusPaths.every((path) => !paidPath.includes(path));
    let regionalsAnimatedSpecialIndividuals =
      paidPath &&
      animatedRegionalsPaths.every((path) => !paidPath.includes(path)) &&
      !paidPath.includes(`prime-membership-${language}`) &&
      !paidPath.includes(`${language}-animation-membership`);
    let regionalsExpertSpecialIndividuals = paidPath && !paidPath.includes(`${language}-expert-membership`);

    return (
      <Fragment>
        {country === 'IN' &&
        (noPaidPath ||
          (courseTheme === 'originals' && originalsSpecialIndividuals) ||
          (courseTheme === 'partner-plus' && partnerPlusSpecialIndividuals) ||
          (courseTheme === 'regionals-animation' && regionalsAnimatedSpecialIndividuals) ||
          (courseTheme === 'regionals-expert' && regionalsExpertSpecialIndividuals)) &&
        pricing &&
        Object.keys(pricing).length !== 0 &&
        pricing[country] ? (
          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
        ) : (
          <Fragment>
            {upComing && <CourseTag upComing>upcoming</CourseTag>}
            {newCourse && <CourseTag newCourse>new</CourseTag>}
            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
          </Fragment>
        )}
      </Fragment>
    );
  };

  render() {
    const {
      isFromInterview,
      isFromRegionalsMain,
      variant,
      isDashboard,
      darkTheme,
      language,
      coursesLanguage,
      courseCategory,
      country,
      packagesDropdown,
      userPaidStatus,
      paidPath,
    } = this.props;
    const { activeGroup, activePartnerGroup, activeRegionalsLang, activeRegionalsTab, activeRegionalsGroup, activeJuniorsGroup, activeVariant } = this.state;
    let cloudFront = config.cloudFront;
    let noPaidPath = !userPaidStatus || paidPath === undefined;
    let originalsSpecialIndividuals = paidPath && originalsPaths.every((path) => !paidPath.includes(path));

    if (packagesDropdown) {
      return (
        <LargeOuterContainer style={{ marginLeft: '14px' }}>
          <HeaderItem
            // variant={variant}
            isDashboard={isDashboard}
            noMargin
            isFromInterview={isFromInterview}
          >
            Packages
            <RiArrowDownSLine />
          </HeaderItem>
          <LargeRegionalsOuterWrapper id="largePackagesNav" isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
            <LargeRegionalsInnerHeader
              // variant={variant}
              isFromInterview={isFromInterview}
              darkTheme={darkTheme}
            >
              Packages
            </LargeRegionalsInnerHeader>
            <LargeRegionalsInnerWrapper isDashboard={isDashboard} isFromInterview={isFromInterview} darkTheme={darkTheme}>
              {originalPackages.map(({ id, title, img, whiteImg, pricing, upComing, newCourse, specialOffer }) => (
                <LargeRegionalsCourse isDashboard={isDashboard} isFromInterview={isFromInterview} key={title} onClick={() => this.handlePackagesNav(id)}>
                  <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                  <div>
                    <p className="fs-15">{title}</p>

                    {country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                      <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                    ) : (
                      <Fragment>
                        {upComing && <CourseTag upComing>upcoming</CourseTag>}
                        {newCourse && <CourseTag newCourse>new</CourseTag>}
                        {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                      </Fragment>
                    )}
                  </div>
                </LargeRegionalsCourse>
              ))}
              {/*{country === 'IN' && (
                <Fragment>
                  <MobileNavHrLine isFromInterview={isFromInterview} isDashboard={isDashboard} />
                  {regionalLanguage.map(({ id, img, whiteImg, language, title }) => (
                    <LargeRegionalsCourse isDashboard={isDashboard} isFromInterview={isFromInterview} key={id} onClick={() => this.handleRegionalLanguage(id)}>
                      <RegionalsLangIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                      <span className="fs-15">
                        {title} Courses ({language})
                      </span>
                    </LargeRegionalsCourse>
                  ))}
                </Fragment>
              )}*/}
            </LargeRegionalsInnerWrapper>
          </LargeRegionalsOuterWrapper>
        </LargeOuterContainer>
      );
    }
    // else if (isFromRegionalsMain) {
    //   return (
    //     <LargeOuterContainer style={{ marginLeft: '14px' }}>
    //       <HeaderItem isDashboard={isDashboard} noMargin isFromInterview={isFromInterview} variant={variant}>
    //         Regional courses
    //         <RiArrowDownSLine />
    //       </HeaderItem>
    //       <LargeInnerContainer id="largeRegionalsNav">
    //         <LargeInnerWrapper isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //           <LargeNavWrapper variant={variant} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //             {regionalLanguage.map(({ id, title, language }) => {
    //               return (
    //                 <LargeNavBtn key={id} navActive={activeRegionalsLang === id} onClick={() => this.handleRegionalsLangGroup(id)}>
    //                   <LargeNavTitle variant={variant} navActive={activeRegionalsLang === id} style={{ lineHeight: '1.35rem' }}>
    //                     <span className={`headingFont ${activeRegionalsLang === id ? 'weight-600' : 'weight-500'}`}>{language}</span> courses
    //                   </LargeNavTitle>
    //                   <LargeNavIcon navActive={activeRegionalsLang === id}>
    //                     <BsCaretRightFill />
    //                   </LargeNavIcon>
    //                 </LargeNavBtn>
    //               );
    //             })}
    //           </LargeNavWrapper>

    //           <LargeCoursesSection isDashboard={isDashboard} isFromInterview={isFromInterview} tabview={true}>
    //             <DurationTabsDivisionWrapper>
    //               <DurationTabsDivision selectedTab={activeRegionalsTab === 'animation' && 'firstTab'} variant={'regionals'}>
    //                 <DurationTab active={activeRegionalsTab === 'animation'} onClick={() => this.handleRegionalsCourseTab('animation')}>
    //                   Animated courses
    //                 </DurationTab>
    //                 <DurationTab
    //                   active={activeRegionalsTab === 'professional'}
    //                   nonclickable={!regionalCourses[activeRegionalsLang]['professional']}
    //                   onClick={() => {
    //                     if (regionalCourses[activeRegionalsLang]['professional']) {
    //                       this.handleRegionalsCourseTab('professional');
    //                     }
    //                   }}
    //                 >
    //                   Expert courses
    //                 </DurationTab>
    //               </DurationTabsDivision>
    //             </DurationTabsDivisionWrapper>

    //             <LargeCoursesWrapper tabview={true} isDashboard={isDashboard} isFromInterview={isFromInterview} darkTheme={darkTheme}>
    //               {regionalCourses[activeRegionalsLang][activeRegionalsTab] &&
    //                 regionalCourses[activeRegionalsLang][activeRegionalsTab].map(
    //                   ({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer }) => (
    //                     <LargeCoursesCard
    //                       key={id}
    //                       isDashboard={isDashboard}
    //                       isFromInterview={isFromInterview}
    //                       nonClickable={upComing}
    //                       onClick={() => {
    //                         !upComing && this.handleRegionalCoursesNav(id);
    //                       }}
    //                     >
    //                       <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                       <div className="d-flex flex-column">
    //                         <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                           {title}
    //                         </LargeCoursesTitle>
    //                         <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                           {desc}
    //                         </LargeCoursesDescription>

    //                         {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                         {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                         {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                         {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                         {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
    //                       </div>
    //                     </LargeCoursesCard>
    //                   )
    //                 )}
    //             </LargeCoursesWrapper>
    //           </LargeCoursesSection>
    //         </LargeInnerWrapper>
    //       </LargeInnerContainer>
    //     </LargeOuterContainer>
    //   );
    // }
    // else if (variant === 'regionals') {
    //   return (
    //     <LargeOuterContainer style={{ marginLeft: '14px' }}>
    //       <HeaderItem isDashboard={isDashboard} noMargin isFromInterview={isFromInterview} variant={variant}>
    //         <span className="pr-1">{coursesLanguage}</span> courses
    //         <RiArrowDownSLine />
    //       </HeaderItem>
    //       <LargeInnerContainer id="largeRegionalCoursesNav">
    //         <LargeInnerWrapper isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //           <LargeNavWrapper variant={variant} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //             {regionalCourseTypes[language] &&
    //               Object.keys(regionalCourseTypes[language]) &&
    //               Object.keys(regionalCourseTypes[language]).map((groupName) => (
    //                 <Fragment key={groupName}>
    //                   {regionalCourseTypes[language][groupName] ? (
    //                     <LargeNavBtn navActive={activeRegionalsGroup === groupName} onClick={() => this.handleRegionalsCourseGroup(groupName)}>
    //                       <LargeNavTitle variant={variant} navActive={activeRegionalsGroup === groupName}>
    //                         {regionalCourseTypes[language][groupName]}
    //                       </LargeNavTitle>
    //                       <LargeNavIcon navActive={activeRegionalsGroup === groupName}>
    //                         <BsCaretRightFill />
    //                       </LargeNavIcon>
    //                     </LargeNavBtn>
    //                   ) : null}
    //                 </Fragment>
    //               ))}
    //           </LargeNavWrapper>

    //           <LargeCoursesSection isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //             <LargeCoursesWrapper isDashboard={isDashboard} isFromInterview={isFromInterview} darkTheme={darkTheme}>
    //               {regionalCourses[language][activeRegionalsGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer }) => (
    //                 <LargeCoursesCard
    //                   key={id}
    //                   isDashboard={isDashboard}
    //                   isFromInterview={isFromInterview}
    //                   nonClickable={upComing}
    //                   onClick={() => {
    //                     !upComing && this.handleRegionalCoursesNav(id);
    //                   }}
    //                 >
    //                   <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                   <div className="d-flex flex-column">
    //                     <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                       {title}
    //                     </LargeCoursesTitle>
    //                     <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                       {desc}
    //                     </LargeCoursesDescription>

    //                     {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                     {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                     {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                     {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                     {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
    //                   </div>
    //                 </LargeCoursesCard>
    //               ))}
    //             </LargeCoursesWrapper>
    //           </LargeCoursesSection>
    //         </LargeInnerWrapper>
    //       </LargeInnerContainer>
    //     </LargeOuterContainer>
    //   );
    // }
    // else if (variant === 'partner-plus') {
    //   return (
    //     <LargeOuterContainer style={{ marginLeft: '14px' }}>
    //       <HeaderItem isDashboard={isDashboard} noMargin isFromInterview={isFromInterview} variant={variant}>
    //         Partner+ courses
    //         <RiArrowDownSLine />
    //       </HeaderItem>
    //       <LargeInnerContainer id="largePartnerCoursesNav">
    //         <LargeInnerWrapper isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //           <LargeNavWrapper variant={variant} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //             {partnerCourseGroups &&
    //               Object.keys(partnerCourseGroups) &&
    //               Object.keys(partnerCourseGroups).map((groupName) => (
    //                 <Fragment key={groupName}>
    //                   {partnerCourses[groupName] ? (
    //                     <LargeNavBtn navActive={activePartnerGroup === groupName} onClick={() => this.handlePartnerCourseGroup(groupName)}>
    //                       <LargeNavTitle variant={variant} navActive={activePartnerGroup === groupName}>
    //                         {partnerCourseGroups[groupName]}
    //                       </LargeNavTitle>
    //                       <LargeNavIcon navActive={activePartnerGroup === groupName}>
    //                         <BsCaretRightFill />
    //                       </LargeNavIcon>
    //                     </LargeNavBtn>
    //                   ) : null}
    //                 </Fragment>
    //               ))}
    //           </LargeNavWrapper>

    //           <LargeCoursesSection isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //             <LargeCoursesWrapper isDashboard={isDashboard} isFromInterview={isFromInterview} darkTheme={darkTheme}>
    //               {partnerCourses[activePartnerGroup] &&
    //                 partnerCourses[activePartnerGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer }) => (
    //                   <LargeCoursesCard
    //                     key={id}
    //                     isDashboard={isDashboard}
    //                     isFromInterview={isFromInterview}
    //                     nonClickable={upComing}
    //                     onClick={() => {
    //                       !upComing && this.handleCoursesNav(id);
    //                     }}
    //                   >
    //                     <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                     <div className="d-flex flex-column">
    //                       <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                         {title}
    //                       </LargeCoursesTitle>
    //                       <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                         {desc}
    //                       </LargeCoursesDescription>

    //                       {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                       {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                       {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                       {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                       {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
    //                     </div>
    //                   </LargeCoursesCard>
    //                 ))}
    //             </LargeCoursesWrapper>
    //           </LargeCoursesSection>
    //         </LargeInnerWrapper>
    //       </LargeInnerContainer>
    //     </LargeOuterContainer>
    //   );
    // }
    else if (variant === 'code-juniors') {
      return (
        <LargeOuterContainer style={{ marginLeft: '14px' }}>
          <HeaderItem
            isDashboard={isDashboard}
            noMargin
            isFromInterview={isFromInterview}
            // variant={variant}
          >
            Browse Courses
            <RiArrowDownSLine />
          </HeaderItem>
          <LargeInnerContainer id="largeOriginalCoursesNav">
            <LargeInnerWrapper isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
              <LargeNavWrapper
                // variant={variant}
                darkTheme={darkTheme}
                isFromInterview={isFromInterview}
                primePricing={noPaidPath || originalsSpecialIndividuals}
              >
                {juniorsCourseGroups &&
                  Object.keys(juniorsCourseGroups) &&
                  Object.keys(juniorsCourseGroups).map((groupName) => (
                    <Fragment key={groupName}>
                      {juniorsCourses[groupName] ? (
                        <LargeNavBtn navActive={activeVariant === 'code-juniors' && activeJuniorsGroup === groupName} onClick={() => this.handleJuinorsCourseGroup(groupName)}>
                          <LargeNavTitle variant={variant} navActive={activeVariant === 'code-juniors' && activeJuniorsGroup === groupName}>
                            {juniorsCourseGroups[groupName]}
                          </LargeNavTitle>
                          <LargeNavIcon navActive={activeVariant === 'code-juniors' && activeJuniorsGroup === groupName}>
                            <BsCaretRightFill />
                          </LargeNavIcon>
                        </LargeNavBtn>
                      ) : null}
                    </Fragment>
                  ))}

                <div className="d-flex align-items-center text-light fs-15 headingFont weight-500 py-2">
                  <img className="mr-2" style={{ width: '18px' }} src={'/Assets/sidemenu-courses-icon-white.svg'} alt="" />
                  Original courses
                </div>

                {Object.keys(courseGroupNames).map((groupName) => (
                  <Fragment key={groupName}>
                    {originalCourses[groupName] ? (
                      <LargeNavBtn navActive={activeVariant === 'originals' && activeGroup === groupName} onClick={() => this.handleCourseGroup(groupName)}>
                        <LargeNavTitle variant={variant} navActive={activeVariant === 'originals' && activeGroup === groupName}>
                          {courseGroupNames[groupName]}
                        </LargeNavTitle>
                        <LargeNavIcon navActive={activeVariant === 'originals' && activeGroup === groupName}>
                          <BsCaretRightFill />
                        </LargeNavIcon>
                      </LargeNavBtn>
                    ) : null}
                  </Fragment>
                ))}

                {Object.keys(partnerCourseGroups).map((groupName) => (
                  <Fragment key={groupName}>
                    {partnerCourses[groupName] ? (
                      <LargeNavBtn navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName} onClick={() => this.handlePartnerCourseGroup(groupName)}>
                        <LargeNavTitle variant={variant} navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName}>
                          {partnerCourseGroups[groupName]}
                        </LargeNavTitle>
                        <LargeNavIcon navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName}>
                          <BsCaretRightFill />
                        </LargeNavIcon>
                      </LargeNavBtn>
                    ) : null}
                  </Fragment>
                ))}

                {country === 'IN' && (
                  <Fragment>
                    <div className="d-flex align-items-center text-light fs-15 headingFont weight-500 py-2">
                      <img className="mr-2" style={{ width: '18px' }} src={`${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`} alt="" />
                      Regional courses
                    </div>
                    {regionalLanguage.map(({ id, title, language }) => {
                      return (
                        <Fragment key={id}>
                          {Object.keys(regionalCourseTypes[id]).map((groupName) => {
                            if (groupName === 'animation') {
                              return (
                                <Fragment key={`${id}-animation`}>
                                  {regionalCourseTypes[id]['animation'] ? (
                                    <LargeNavBtn
                                      navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}
                                      onClick={() => this.handleRegionalsCourseGroup(id, 'animation')}
                                    >
                                      <LargeNavTitle variant={variant} navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        {regionalCourseTypes[id]['animation']}
                                      </LargeNavTitle>
                                      <LargeNavIcon navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        <BsCaretRightFill />
                                      </LargeNavIcon>
                                    </LargeNavBtn>
                                  ) : null}
                                </Fragment>
                              );
                            } else return null;
                          })}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                )}
              </LargeNavWrapper>

              <LargeCoursesSection isDashboard={isDashboard} isFromInterview={isFromInterview}>
                {this._renderTopGroupInfo(activeVariant)}

                <LargeCoursesWrapper
                  isDashboard={isDashboard}
                  isFromInterview={isFromInterview}
                  darkTheme={darkTheme}
                  primePricing={noPaidPath || originalsSpecialIndividuals}
                  topInfo={activeVariant === 'partner-plus'}
                >
                  {activeVariant === 'code-juniors' &&
                    juniorsCourses[activeJuniorsGroup] &&
                    juniorsCourses[activeJuniorsGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                      <LargeCoursesCard
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div className="d-flex flex-column">
                          <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </LargeCoursesTitle>
                          <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {desc}
                          </LargeCoursesDescription>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'code-juniors')}

                          {/*{upComing && <CourseTag upComing>upcoming</CourseTag>}
                          {newCourse && <CourseTag newCourse>new</CourseTag>}
                          {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                          {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                          {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}*/}
                        </div>
                      </LargeCoursesCard>
                    ))}

                  {activeVariant === 'originals' &&
                    originalCourses[activeGroup] &&
                    originalCourses[activeGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                      <LargeCoursesCard
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div className="d-flex flex-column">
                          <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </LargeCoursesTitle>
                          <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {desc}
                          </LargeCoursesDescription>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'originals')}

                          {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                            <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                          ) : (
                            <Fragment>
                              {upComing && <CourseTag upComing>upcoming</CourseTag>}
                              {newCourse && <CourseTag newCourse>new</CourseTag>}
                              {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                              {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                              {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                            </Fragment>
                          )}*/}
                        </div>
                      </LargeCoursesCard>
                    ))}

                  {activeVariant === 'partner-plus' &&
                    partnerCourses[activePartnerGroup] &&
                    partnerCourses[activePartnerGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                      <LargeCoursesCard
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div className="d-flex flex-column">
                          <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </LargeCoursesTitle>
                          <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {desc}
                          </LargeCoursesDescription>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'partner-plus')}

                          {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                            <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                          ) : (
                            <Fragment>
                              {upComing && <CourseTag upComing>upcoming</CourseTag>}
                              {newCourse && <CourseTag newCourse>new</CourseTag>}
                              {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                              {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                              {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                            </Fragment>
                          )}*/}
                        </div>
                      </LargeCoursesCard>
                    ))}

                  {activeVariant === 'regionals-animation' &&
                    regionalCourses[activeRegionalsLang] &&
                    regionalCourses[activeRegionalsLang]['animation'].map(
                      ({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                        <LargeCoursesCard
                          key={id}
                          isDashboard={isDashboard}
                          isFromInterview={isFromInterview}
                          nonClickable={upComing}
                          onClick={() => {
                            !upComing && this.handleRegionalCoursesNav(id);
                          }}
                        >
                          <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                          <div className="d-flex flex-column">
                            <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {title}
                            </LargeCoursesTitle>
                            <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {desc}
                            </LargeCoursesDescription>

                            {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-animation', activeRegionalsLang)}

                            {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                              <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                            ) : (
                              <Fragment>
                                {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                {newCourse && <CourseTag newCourse>new</CourseTag>}
                                {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                              </Fragment>
                            )}*/}
                          </div>
                        </LargeCoursesCard>
                      )
                    )}
                </LargeCoursesWrapper>
              </LargeCoursesSection>

              {noPaidPath || originalsSpecialIndividuals ? <Fragment>{this._renderPrimeNavBar()}</Fragment> : null}
            </LargeInnerWrapper>
          </LargeInnerContainer>
        </LargeOuterContainer>
      );
    } else {
      return (
        <LargeOuterContainer style={{ marginLeft: '14px' }}>
          <HeaderItem
            isDashboard={isDashboard}
            noMargin
            isFromInterview={isFromInterview}
            // variant={variant}
          >
            Browse Courses
            <RiArrowDownSLine />
          </HeaderItem>
          <LargeInnerContainer id="largeCoursesNav">
            <LargeInnerWrapper isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
              <LargeNavWrapper
                // variant={variant}
                darkTheme={darkTheme}
                isFromInterview={isFromInterview}
                primePricing={noPaidPath || originalsSpecialIndividuals}
              >
                {variant === 'regionals' && (
                  <Fragment>
                    {courseCategory === 'professional' && (
                      <Fragment>
                        <div className="pb-2">
                          {regionalLanguage.map(({ id, title, language }) => {
                            return (
                              <Fragment key={id}>
                                {Object.keys(regionalCourseTypes[id]).map((groupName) => {
                                  if (groupName === 'professional') {
                                    return (
                                      <Fragment key={`${id}-professional`}>
                                        {regionalCourseTypes[id]['professional'] ? (
                                          <LargeNavBtn
                                            navActive={activeVariant === 'regionals-expert' && activeRegionalsLang === id}
                                            onClick={() => this.handleRegionalsCourseGroup(id, 'professional')}
                                          >
                                            <LargeNavTitle variant={variant} navActive={activeVariant === 'regionals-expert' && activeRegionalsLang === id}>
                                              {regionalCourseTypes[id]['professional']}
                                            </LargeNavTitle>
                                            <LargeNavIcon navActive={activeVariant === 'regionals-expert' && activeRegionalsLang === id}>
                                              <BsCaretRightFill />
                                            </LargeNavIcon>
                                          </LargeNavBtn>
                                        ) : null}
                                      </Fragment>
                                    );
                                  } else return null;
                                })}
                              </Fragment>
                            );
                          })}
                        </div>

                        <div className="d-flex align-items-center text-light fs-15 headingFont weight-500 pb-2">
                          <img className="mr-2" style={{ width: '18px' }} src={`${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`} alt="" />
                          Regional courses
                        </div>
                      </Fragment>
                    )}

                    {regionalLanguage.map(({ id, title, language }) => {
                      return (
                        <Fragment key={id}>
                          {Object.keys(regionalCourseTypes[id]).map((groupName) => {
                            if (groupName === 'animation') {
                              return (
                                <Fragment key={`${id}-animation`}>
                                  {regionalCourseTypes[id]['animation'] ? (
                                    <LargeNavBtn
                                      navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}
                                      onClick={() => this.handleRegionalsCourseGroup(id, 'animation')}
                                    >
                                      <LargeNavTitle variant={variant} navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        {regionalCourseTypes[id]['animation']}
                                      </LargeNavTitle>
                                      <LargeNavIcon navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        <BsCaretRightFill />
                                      </LargeNavIcon>
                                    </LargeNavBtn>
                                  ) : null}
                                </Fragment>
                              );
                            } else return null;
                          })}
                        </Fragment>
                      );
                    })}

                    <div className="d-flex align-items-center text-light fs-15 headingFont weight-500 py-2">
                      <img className="mr-2" style={{ width: '18px' }} src={'/Assets/sidemenu-courses-icon-white.svg'} alt="" />
                      Original courses
                    </div>
                  </Fragment>
                )}

                {Object.keys(courseGroupNames).map((groupName) => (
                  <Fragment key={groupName}>
                    {originalCourses[groupName] ? (
                      <LargeNavBtn navActive={activeVariant === 'originals' && activeGroup === groupName} onClick={() => this.handleCourseGroup(groupName)}>
                        <LargeNavTitle variant={variant} navActive={activeVariant === 'originals' && activeGroup === groupName}>
                          {courseGroupNames[groupName]}
                        </LargeNavTitle>
                        <LargeNavIcon navActive={activeVariant === 'originals' && activeGroup === groupName}>
                          <BsCaretRightFill />
                        </LargeNavIcon>
                      </LargeNavBtn>
                    ) : null}
                  </Fragment>
                ))}

                {Object.keys(partnerCourseGroups).map((groupName) => (
                  <Fragment key={groupName}>
                    {partnerCourses[groupName] ? (
                      <LargeNavBtn navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName} onClick={() => this.handlePartnerCourseGroup(groupName)}>
                        <LargeNavTitle variant={variant} navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName}>
                          {partnerCourseGroups[groupName]}
                        </LargeNavTitle>
                        <LargeNavIcon navActive={activeVariant === 'partner-plus' && activePartnerGroup === groupName}>
                          <BsCaretRightFill />
                        </LargeNavIcon>
                      </LargeNavBtn>
                    ) : null}
                  </Fragment>
                ))}

                {country === 'IN' && variant !== 'regionals' && (
                  <Fragment>
                    <div className="d-flex align-items-center text-light fs-15 headingFont weight-500 py-2">
                      <img className="mr-2" style={{ width: '18px' }} src={`${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`} alt="" />
                      Regional courses
                    </div>
                    {regionalLanguage.map(({ id, title, language }) => {
                      return (
                        <Fragment key={id}>
                          {Object.keys(regionalCourseTypes[id]).map((groupName) => {
                            if (groupName === 'animation') {
                              return (
                                <Fragment key={`${id}-animation`}>
                                  {regionalCourseTypes[id]['animation'] ? (
                                    <LargeNavBtn
                                      navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}
                                      onClick={() => this.handleRegionalsCourseGroup(id, 'animation')}
                                    >
                                      <LargeNavTitle variant={variant} navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        {regionalCourseTypes[id]['animation']}
                                      </LargeNavTitle>
                                      <LargeNavIcon navActive={activeVariant === 'regionals-animation' && activeRegionalsLang === id}>
                                        <BsCaretRightFill />
                                      </LargeNavIcon>
                                    </LargeNavBtn>
                                  ) : null}
                                </Fragment>
                              );
                            } else return null;
                          })}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                )}
              </LargeNavWrapper>

              <LargeCoursesSection isDashboard={isDashboard} isFromInterview={isFromInterview}>
                {this._renderTopGroupInfo(activeVariant)}

                <LargeCoursesWrapper
                  isDashboard={isDashboard}
                  isFromInterview={isFromInterview}
                  darkTheme={darkTheme}
                  primePricing={noPaidPath || originalsSpecialIndividuals}
                  topInfo={activeVariant === 'partner-plus' || activeVariant === 'regionals-expert'}
                >
                  {activeVariant === 'originals' &&
                    originalCourses[activeGroup] &&
                    originalCourses[activeGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                      <LargeCoursesCard
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div className="d-flex flex-column">
                          <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </LargeCoursesTitle>
                          <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {desc}
                          </LargeCoursesDescription>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'originals')}

                          {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                            <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                          ) : (
                            <Fragment>
                              {upComing && <CourseTag upComing>upcoming</CourseTag>}
                              {newCourse && <CourseTag newCourse>new</CourseTag>}
                              {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                              {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                              {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                            </Fragment>
                          )}*/}
                        </div>
                      </LargeCoursesCard>
                    ))}

                  {activeVariant === 'partner-plus' &&
                    partnerCourses[activePartnerGroup] &&
                    partnerCourses[activePartnerGroup].map(({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                      <LargeCoursesCard
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div className="d-flex flex-column">
                          <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </LargeCoursesTitle>
                          <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {desc}
                          </LargeCoursesDescription>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'partner-plus')}

                          {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                            <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                          ) : (
                            <Fragment>
                              {upComing && <CourseTag upComing>upcoming</CourseTag>}
                              {newCourse && <CourseTag newCourse>new</CourseTag>}
                              {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                              {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                              {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                            </Fragment>
                          )}*/}
                        </div>
                      </LargeCoursesCard>
                    ))}

                  {activeVariant === 'regionals-animation' &&
                    regionalCourses[activeRegionalsLang] &&
                    regionalCourses[activeRegionalsLang]['animation'].map(
                      ({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                        <LargeCoursesCard
                          key={id}
                          isDashboard={isDashboard}
                          isFromInterview={isFromInterview}
                          nonClickable={upComing}
                          onClick={() => {
                            !upComing && this.handleRegionalCoursesNav(id);
                          }}
                        >
                          <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                          <div className="d-flex flex-column">
                            <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {title}
                            </LargeCoursesTitle>
                            <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {desc}
                            </LargeCoursesDescription>

                            {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-animation', activeRegionalsLang)}

                            {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                              <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                            ) : (
                              <Fragment>
                                {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                {newCourse && <CourseTag newCourse>new</CourseTag>}
                                {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                              </Fragment>
                            )}*/}
                          </div>
                        </LargeCoursesCard>
                      )
                    )}

                  {activeVariant === 'regionals-expert' &&
                    regionalCourses[activeRegionalsLang] &&
                    regionalCourses[activeRegionalsLang]['professional'].map(
                      ({ id, title, img, whiteImg, desc, upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing }) => (
                        <LargeCoursesCard
                          key={id}
                          isDashboard={isDashboard}
                          isFromInterview={isFromInterview}
                          nonClickable={upComing}
                          onClick={() => {
                            !upComing && this.handleRegionalCoursesNav(id);
                          }}
                        >
                          <CoursesIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                          <div className="d-flex flex-column">
                            <LargeCoursesTitle isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {title}
                            </LargeCoursesTitle>
                            <LargeCoursesDescription isDashboard={isDashboard} isFromInterview={isFromInterview}>
                              {desc}
                            </LargeCoursesDescription>

                            {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-expert', activeRegionalsLang)}

                            {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                              <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                            ) : (
                              <Fragment>
                                {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                {newCourse && <CourseTag newCourse>new</CourseTag>}
                                {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                              </Fragment>
                            )}*/}
                          </div>
                        </LargeCoursesCard>
                      )
                    )}
                </LargeCoursesWrapper>
              </LargeCoursesSection>

              {noPaidPath || originalsSpecialIndividuals ? <Fragment>{this._renderPrimeNavBar()}</Fragment> : null}
            </LargeInnerWrapper>
          </LargeInnerContainer>
        </LargeOuterContainer>
      );
    }
  }
}

const mapStateToProps = ({ Dashboard }) => ({
  userPaidStatus: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.paidStatus,
  paidPath: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.path,
});

export default connect(mapStateToProps, null)(CoursesLargeNav);
